module.exports = __webpack_public_path__ + "static/media/DM.eecccf82.svg";